import BaseCache from '@panda/cache/src/base/cache';
import { RESPONSE_CODE } from '@panda/cache/src/base/define';
import { Toast } from 'vant';
import Vue from 'vue';
import { login } from '@/util/login';

BaseCache.ERROR_HANDLER = {
  [RESPONSE_CODE.UN_LOGIN]: () => {
    // 未登录
    console.log('未登录');
    login();
  },
  [RESPONSE_CODE.MODAL]: (message: string) => {
    Vue.prototype.$dialog.alert({ message });
  },
  [RESPONSE_CODE.NOTIFY]: (message: string) => {
    Toast(message);
  },
  [RESPONSE_CODE.PARAM_ERROR]: () => {
    Toast('请求错误，请稍后尝试');
  },
};

let loading: null | { clear: () => void } = null;
let loadingCount = 0;

BaseCache.LOADING = {
  show() {
    loadingCount += 1;
    if (loading) {
      return;
    }
    loading = Toast.loading({
      duration: 0, // 持续展示 toast
      forbidClick: true,
      loadingType: 'spinner',
    });
  },
  hide() {
    loadingCount -= 1;
    if (loadingCount < 1 && loading) {
      // 手动清除 Toast
      loading.clear();
      loading = null;
    }
  },
};
